import { NodeEntry, Text } from 'slate'; // noinspection CommaExpressionJS
import { FontSizeModeEnum } from './types';

/**
 * Decorate all texts to resize font.
 */
export const decorateFontSizeSwitcher = (fontSizeMode: FontSizeModeEnum) => ([
  node,
  path,
]: NodeEntry) => {
  const ranges: any[] = [];

  if (Text.isText(node)) {
    const { text } = node;
    let start = 0;
    const end = start + text.length;
    ranges.push({
      anchor: { path, offset: start },
      focus: { path, offset: end },
      fontSizeMode,
    });

    start = end;
  }

  return ranges;
};
